import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ShipOrderSku } from 'src/app/models/fbmOrders.model';

@Component({
  selector: 'app-fbm-skus',
  templateUrl: './fbm-skus.component.html',
  styleUrls: ['./fbm-skus.component.scss']
})
export class FbmSkusComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() skuList: Array<ShipOrderSku>;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
